import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { makeIcon } from './envetMarker.utils';
import { getInitialStyle } from './eventMarker.style';

export class Toggle extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {},
        PlayIcon: makeIcon('Play'),
        PauseIcon: makeIcon('Pause'),
      },
      getInitialStyle(),
    );
  }

  static _states() {
    return [
      class Playing extends this {
        $enter() {
          this.tag('PlayIcon').visible = true;
          this.tag('PauseIcon').visible = false;
          super.$enter();
        }
      },
      class Paused extends this {
        $enter() {
          this.tag('PlayIcon').visible = false;
          this.tag('PauseIcon').visible = true;
          super.$enter();
        }
      },
    ];
  }

  $enter() {
    if (!this.transitionAnimation) {
      this.transitionAnimation = this.animation({
        duration: 1,
        stopMethod: 'immediate',
        actions: [
          {
            p: 'scale',
            v: {
              0: { v: 1 },
              1: { v: 1.5 },
            },
          },
          {
            p: 'alpha',
            v: {
              0: { v: 0 },
              0.3: { v: 0.3 },
              0.4: { v: 0.4 },
              0.5: { v: 0.5 },
              0.6: { v: 0.5 },
              0.8: { v: 0.3 },
              1: { v: 0 },
            },
          },
        ],
      });
    }

    this.transitionAnimation.start();
  }

  show(state) {
    this._setState(state);
  }
}
